import React, { useContext, useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import {
  CREATE_CHART,
  UPDATE_CHART,
  GET_CHART
} from '@nile/reports/src/modules/charts/graphql';
import {
  AccountClient,
  useCachedQuery,
  RMMClient,
  GET_ENTITY_PROPERTIES
} from '@nile/graphql';
import ChartSheet from '@nile/reports/src/modules/charts/components/subpages/ChartSheet';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { withErrorBoundary, SkeletonLoading } from '@nile/components';
import ReportsContext from '@nile/reports/src/modules/home/contexts/Reports';
import { withRouter } from 'react-router-dom';
import { sortBy } from 'lodash';

function ChartCascade(props) {
  const { chartId, source, numberChartCallback } = props;

  const flags = useFlags();

  const [chart, setChart] = useState(null);
  const [loading, setLoading] = useState(false);
  const reportsContext = useContext(ReportsContext);

  const { loading: metaLoading, data: meta } = useCachedQuery(
    GET_ENTITY_PROPERTIES,
    {
      client: RMMClient
    }
  );

  const getChartDetails = (id) => {
    setLoading(true);
    AccountClient.query({
      query: GET_CHART,
      variables: {
        chartId: id
      },
      fetchPolicy: 'network-only'
    })
      .then((res) => {
        if (res?.data?.getChart) {
          const sortedChart = {
            ...res.data.getChart,
            metrics: sortBy(res?.data?.getChart?.metrics, 'metricOrder', 'asc')
          };
          setChart(sortedChart);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  const [createNewChart] = useMutation(CREATE_CHART, {
    client: AccountClient,
    onCompleted({ createChart }) {
      setChart(createChart);
      reportsContext.setChartListMeta({
        refresh: true,
        data: { resetPage: true }
      });
    }
  });

  const [updateCharts] = useMutation(UPDATE_CHART, {
    client: AccountClient,
    onCompleted({ updateChart }) {
      setChart(updateChart);
    }
  });

  useEffect(() => {
    if (chartId) {
      getChartDetails(chartId);
    }
  }, [chartId]);

  if (loading || metaLoading) {
    return (
      <div className="bg-white br10">
        <SkeletonLoading
          hideStepNav
          hideTable
          showCardView
          hideSecondaryHeader
          cardViewCustomClassName="full-width vh55 m20 rounded-4px"
        />
      </div>
    );
  }

  return (
    <>
      <ChartSheet
        data={chart}
        flags={flags}
        metaLoading={metaLoading}
        meta={meta?.getEntitiesMeta || []}
        source={source}
        createNewChart={createNewChart}
        updateCharts={updateCharts}
        setLoading={setLoading}
        reportContext={reportsContext}
        numberChartCallback={numberChartCallback}
      />
    </>
  );
}

export default withRouter(withErrorBoundary(ChartCascade));
